var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0516 10.8978L17.9626 15.7791L3.0249 1.09641C3.7749 0.661967 4.75172 0.591326 5.61513 1.07875L23.0516 10.9013V10.8978Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1792 22.4936L5.61835 32.3869C4.56836 32.9802 3.35007 32.7507 2.57812 32.0372L17.9658 17.3545L23.1792 22.4971V22.4936Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0658 18.8494L24.0317 21.6856L23.9915 21.7068L18.7781 16.5642L23.8671 11.6829L23.9073 11.7041L29.0658 14.611C30.7451 15.5575 30.7451 17.8993 29.0658 18.8459V18.8494Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76217 31.2494C1.76217 31.2494 1.74022 31.2282 1.72925 31.2212C1.27559 30.7867 0.98291 30.1863 0.98291 29.4834V3.97855C0.98291 3.07082 1.47315 2.32556 2.17193 1.90172C2.18656 1.89465 2.19754 1.88759 2.21217 1.88052L17.1499 16.5632L1.76217 31.2459V31.2494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.9f27d23eada196461f6dfcf6adff869f.svg";
export { ForwardRef as ReactComponent };